import type { IEmailCampaignDesignStatus } from "api/rpc/2024-04/facilityAdmin/marketing/emailBuilderTypes";
import type { IEmailMarketingTemplateListItem } from "api/rpc/2024-04/facilityAdmin/marketing/emailMarketingTemplatesTypes";
import {
  EMAIL_BUILDER_BLANK_TEMPLATE_ILLUSTRATION_SRC,
  EMAIL_BUILDER_BLANK_TEMPLATE_NAME,
} from "./emailBuilderTemplateConstants";

export {
  EMAIL_BUILDER_BLANK_TEMPLATE_ILLUSTRATION_SRC,
  EMAIL_BUILDER_BLANK_TEMPLATE_NAME,
} from "./emailBuilderTemplateConstants";

export type TEmailBuilderCampaignEntryDestination = "builder" | "select_template";

export function resolveEmailBuilderCampaignEntryDestination(
  design: IEmailCampaignDesignStatus | null | undefined,
): TEmailBuilderCampaignEntryDestination {
  if (design == null) {
    return "select_template";
  }

  if (design.has_draft) {
    return "builder";
  }

  if (design.active_published_design_id != null) {
    return "builder";
  }

  return "select_template";
}

export function emailBuilderCampaignNeedsTemplateSelection(
  design: IEmailCampaignDesignStatus | null | undefined,
): boolean {
  return resolveEmailBuilderCampaignEntryDestination(design) === "select_template";
}

export function isEmailBuilderBlankSystemTemplate(template: IEmailMarketingTemplateListItem): boolean {
  return template.scope === "system" && template.name === EMAIL_BUILDER_BLANK_TEMPLATE_NAME;
}

export function resolveEmailBuilderTemplateCardPreviewSrc(
  template: IEmailMarketingTemplateListItem,
): string | null {
  if (isEmailBuilderBlankSystemTemplate(template)) {
    return EMAIL_BUILDER_BLANK_TEMPLATE_ILLUSTRATION_SRC;
  }

  if (typeof template.thumbnail_url === "string" && template.thumbnail_url.length > 0) {
    return template.thumbnail_url;
  }

  return null;
}
